import styled from "styled-components";

export const buttonStyles = {
  outline: {
    primary: {
      color: "Primary",
      borderColor: "Primary",
      backgroundColor: "Transparent",
      disabled: "Black24",
    },
    secondary: {
      color: "Secondary",
      borderColor: "Secondary",
      backgroundColor: "Transparent",
      disabled: "Black24",
    },
    gray: {
      color: "Gray",
      borderColor: "Gray",
      backgroundColor: "White",
      disabled: "Black24",
    },
    white: {
      color: "Gray",
      borderColor: "Gray",
      backgroundColor: "White",
      disabled: "Black24",
    },
    danger: {
      color: "Danger",
      borderColor: "Danger",
      backgroundColor: "Transparent",
      disabled: "Black24",
    },
  },
  filled: {
    primary: {
      color: "White",
      borderColor: "Primary",
      backgroundColor: "Primary",
      disabled: "Black24",
    },
    secondary: {
      color: "White",
      borderColor: "Secondary",
      backgroundColor: "Secondary",
      disabled: "Black24",
    },
    violet: {
      color: "White",
      borderColor: "Violet",
      backgroundColor: "Violet",
      disabled: "Black24",
    },
    gray: {
      color: "White",
      borderColor: "Gray",
      backgroundColor: "Gray",
      disabled: "Black24",
    },
    white: {
      color: "Primary",
      borderColor: "Primary",
      backgroundColor: "White",
      disabled: "Black24",
    },
    danger: {
      color: "White",
      borderColor: "Danger",
      backgroundColor: "Danger",
      disabled: "Black24",
    },
  },
  link: {
    primary: {
      color: "Primary",
      borderColor: "Transparent",
      backgroundColor: "Transparent",
    },
    secondary: {
      color: "Secondary",
      borderColor: "Transparent",
      backgroundColor: "Transparent",
    },
    gray: {
      color: "Gray",
      borderColor: "Transparent",
      backgroundColor: "Transparent",
    },
    white: {
      color: "White",
      borderColor: "Transparent",
      backgroundColor: "Transparent",
    },
    danger: {
      color: "Danger",
      borderColor: "Transparent",
      backgroundColor: "Transparent",
    },
  },
};

export const Button = styled("button")<{
  options;
  block?: boolean;
  disabled?: boolean;
}>`
  ${(props: any) => {
    const { options, theme, disabled, style } = props;
    const { size, type, skin, block, marginBottom } = options;
    return `
      font-family: 'Inter',sans-serif;
      cursor: pointer;
      border: none;
      display: inline-flex;
      align-items: center;
      justify-content:center;
       ${
         !(type !== "common" && type !== "link") || skin === "transparent"
           ? ``
           : `border: 1px solid ${
               !disabled
                 ? theme.colors[buttonStyles[type][skin].borderColor]
                 : theme.colors[buttonStyles[type][skin].disabled]
             }`
       };
      ${type !== "link" ? `height: ${theme.button.size[size].height}` : ``};
      background-color: ${
        !disabled
          ? theme.colors[buttonStyles[type][skin].backgroundColor]
          : theme.colors[buttonStyles[type][skin].disabled]
      };
      font-size: ${
        type === "link" ? "inherit" : theme.button.size[size].fontSize
      };
     color: ${theme.colors[buttonStyles[type][skin].color]};
      border-radius: ${theme.button.size[size].borderRadius};
      padding: ${
        type === "link"
          ? "0px"
          : `${!!style?.padding ? style?.padding : `0px 17px`}`
      };
      text-decoration: none;
      letter-spacing: 0.2px;
      font-weight: ${type === "link" ? "normal" : "500"};
      ${block ? `width: 100%;` : ``}
       min-width: ${
         type === "link" ? "0" : `${!!style?.minwidth && style?.minwidth}`
       };
      ${
        type !== "link"
          ? "box-shadow: 3px 3px 6px 0 rgba(112, 112, 112,0.16);"
          : ""
      }
      
      @media (max-width: 500px) {
      height: 26px;
      font-size: 12px;
    }
      text-align: center;
      transition: all .2s ease-in-out;
      margin-bottom: ${marginBottom ? marginBottom : "0px"};
      &:hover {
        ${
          type !== "link"
            ? "box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);"
            : "text-decoration: underline;"
        }
         ${
           type !== "link" &&
           !!options.hoverSkin &&
           `background-color:${
             theme.colors[buttonStyles[type][skin].hoverBackground]
           };
          color:${theme.colors[buttonStyles[type][skin].hoverText]};
          
          `
         }
        
      }
    `;
  }}
`;
